import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawWarningIcon from "./RawWarningIcon.svg.jsx";

const WarningIcon = forwardRef((props, ref) => {
  return (
    <Icon ref={ref} SvgComponent={RawWarningIcon} title="Warning" {...props} />
  );
});

export default WarningIcon;
